/* eslint-disable */
import Vue from 'vue';
import { authHeader, handleResponse } from '../_helpers';


function fetchProcedures() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', ...authHeader() }
    };

    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/getprocedures`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;
        });
}

function fetchTypeAfspraak() {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', ...authHeader() }
    };

    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/appointmenttypes`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;
        });
}

function fetchTypeKlacht(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(data)
    };

    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/complainttypes`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;
        });
}

function fetchLocatie(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(data),
    };
    
    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/locations`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;           
        });
}

function fetchTherapeut(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(data),
    };

    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/therapists`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;
        });
}

function fetchTimeSlots(data) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(data),
    };

    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/timeslots`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;
        });
}

function postFormModel(data, postFormModelRoute) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeader() },
        body: JSON.stringify(data),
    };
    
    return fetch(`${Vue.appConfig.apiBaseUrl}/Praktijk/${postFormModelRoute}`, requestOptions)
        .then(handleResponse)
        .then(res => {
            return res.data;
        });
}

export const services = {
    fetchProcedures: fetchProcedures,
    fetchTypeAfspraak: fetchTypeAfspraak,
    fetchTypeKlacht: fetchTypeKlacht,
    fetchLocatie: fetchLocatie,
    fetchTherapeut: fetchTherapeut,
    fetchTimeSlots: fetchTimeSlots,
    postFormModel: postFormModel
};